// Free-text tags on resource submissions (REQ-059). Typed as one comma-separated
// line; stored as a short, de-duplicated array so search and Admin can use them.
export const MAX_RESOURCE_TAGS = 10;
export const MAX_RESOURCE_TAG_LENGTH = 30;

export function parseResourceTags(text) {
  const seen = new Set();
  const tags = [];
  String(text || '')
    .split(/[,\n]/)
    .forEach((raw) => {
      const tag = raw.trim().replace(/^#+/, '').replace(/\s+/g, ' ').trim().slice(0, MAX_RESOURCE_TAG_LENGTH).trim();
      const key = tag.toLowerCase();
      if (!tag || seen.has(key) || tags.length >= MAX_RESOURCE_TAGS) return;
      seen.add(key);
      tags.push(tag);
    });
  return tags;
}
